var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBathroomIcon = function SvgBathroomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 15 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M0 8h15M4.5 13h6m-6 0a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h2v1.5M4.5 13v2.5m6-2.5a3 3 0 0 0 3-3V8m-3 5v2.5M5 4h3"
  })));
};
export default SvgBathroomIcon;